'use client'

import Footer from "@/components/landing/footer";
import Navbar from "@/components/landing/navbar";
import LandingPageLayout from "@/components/layouts/landing-page-layout";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Separator } from "@/components/ui/separator";
import { useTranslations } from "next-intl";

const TermsPage = () => {
      const t = useTranslations('legal.terms');

      return (
            <LandingPageLayout>
                  <Navbar />
                  <main className="max-w-4xl mx-auto px-4 py-24">
                        <h1 className="text-3xl font-bold mb-4">{t('title')}</h1>
                        <Separator className="mb-4" />
                        <ScrollArea className="flex flex-col gap-8">
                              <section>
                                    <h2 className="text-xl font-semibold mt-8">{t('section1.title')}</h2>
                                    <p>{t('section1.content')}</p>
                              </section>
                              <section>
                                    <h2 className="text-xl font-semibold mt-8">{t('section2.title')}</h2>
                                    <p>{t('section2.content')}</p>
                              </section>
                              <section>
                                    <h2 className="text-xl font-semibold mt-8">{t('section3.title')}</h2>
                                    <p>{t('section3.content')}</p>
                                    <p>{t('section3.is_prohibited')}</p>
                                    <ul className="list-disc pl-10 space-y-2">
                                          <li>{t('section3.item_1')}</li>
                                          <li>{t('section3.item_2')}</li>
                                          <li>{t('section3.item_3')}</li>
                                          <li>{t('section3.item_4')}</li>
                                    </ul>
                              </section>
                              <section>
                                    <h2 className="text-xl font-semibold mt-8">{t('section4.title')}</h2>
                                    <p>{t('section4.content')}</p>

                              </section>
                              <section>
                                    <h2 className="text-xl font-semibold mt-8">{t('section5.title')}</h2>
                                    <p>{t('section5.content')}</p>
                              </section>
                              <section>
                                    <h2 className="text-xl font-semibold mt-8">{t('section6.title')}</h2>
                                    <p>{t('section6.content')}</p>
                              </section>
                              <section>
                                    <h2 className="text-xl font-semibold mt-8">{t('section7.title')}</h2>
                                    <p>{t('section7.content')}</p>
                              </section>
                              <section>
                                    <h2 className="text-xl font-semibold mt-8">{t('section8.title')}</h2>
                                    <p>{t('section8.content')}</p>
                              </section>
                              <section>
                                    <h2 className="text-xl font-semibold mt-8">{t('section9.title')}</h2>
                                    <p>{t('section9.content')}</p>
                              </section>
                              <section>
                                    <h2 className="text-xl font-semibold mt-8">{t('section10.title')}</h2>
                                    <p>{t('section10.content')} <a href="mailto:help@kiwilog.app" className="text-kiwilog">help@kiwilog.app</a></p>
                              </section>
                        </ScrollArea>

                  </main>
                  <Footer />
            </LandingPageLayout>
      );
};

export default TermsPage;